import { render, staticRenderFns } from "./VarejoFaturamentoPage.vue?vue&type=template&id=a7b96476&"
import script from "./VarejoFaturamentoPage.vue?vue&type=script&lang=js&"
export * from "./VarejoFaturamentoPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports